import EmpresaService from "common/services/EmpresaService"
import { useCallback, useState } from "react"

const empresaService = new EmpresaService()

const useRazonSocialAndCif = () => {
  const [empresasID, setEmpresasID] = useState([])
  const [razonesSociales, setRazonesSociales] = useState([])
  const [cifs, setCifs] = useState([])

  const getByCifOrRazonSocial = useCallback(
    async (searchBy: $TSMigrationFixMe, value: $TSMigrationFixMe) => {
      const data = await empresaService.getByRazonSocialOrCif({
        [searchBy]: value,
      })

      const results = data?.hits?.hits
      const { ids, cifs, razonesSociales } = results.reduce(
        (acum: $TSMigrationFixMe, result: $TSMigrationFixMe) => {
          return {
            ids: [...acum.ids, result._id],
            cifs: [...acum.cifs, result._source.cif],
            razonesSociales: [
              ...acum.razonesSociales,
              result._source.razonsocial,
            ],
          }
        },
        { ids: [], cifs: [], razonesSociales: [] }
      )

      setEmpresasID(ids)
      setRazonesSociales(razonesSociales)
      setCifs(cifs)
    },
    []
  )

  const getByCif = useCallback(
    async (searchBy: $TSMigrationFixMe, value: $TSMigrationFixMe) => {
      const data = await empresaService.getByRazonSocialOrCif({
        [searchBy]: value,
      })

      const results = data?.hits?.hits
      return results
    },
    []
  )

  const getRazonSocialByCif = useCallback(
    (cif: $TSMigrationFixMe) => {
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame...
      const indexRazonSocial = cifs.indexOf(cif)
      return razonesSociales[indexRazonSocial]
    },
    [cifs, razonesSociales]
  )

  const getCifByRazonSocial = useCallback(
    (razonSocial: $TSMigrationFixMe) => {
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame...
      const indexCif = razonesSociales.indexOf(razonSocial)
      return cifs[indexCif]
    },
    [cifs, razonesSociales]
  )

  const getEmpresaIDByCif = useCallback(
    (cif: $TSMigrationFixMe) => {
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame...
      const indexRazonID = cifs.indexOf(cif)
      return empresasID[indexRazonID]
    },
    [cifs, empresasID]
  )

  const getEmpresaIDByRazonSocial = useCallback(
    (razonSocial: $TSMigrationFixMe) => {
      // @ts-expect-error TS(2345): Argument of type 'any' is not assignable to parame...
      const indexRazonID = razonesSociales.indexOf(razonSocial)
      return empresasID[indexRazonID]
    },
    [empresasID, razonesSociales]
  )

  return {
    empresasID,
    razonesSociales,
    cifs,
    getByCif,
    getByCifOrRazonSocial,
    getRazonSocialByCif,
    getCifByRazonSocial,
    getEmpresaIDByCif,
    getEmpresaIDByRazonSocial,
  }
}

export default useRazonSocialAndCif
